// https://github.com/amplitude/Amplitude-TypeScript/tree/main/packages/analytics-browser#installing-via-script-loader
// https://www.docs.developers.amplitude.com/data/sdks/sdk-quickstart/#initialize-the-library
!function(){"use strict";if(window.__oyLoginV2TrackingSilence===true){return}!function(e,t){var r=e.amplitude||{_q:[],_iq:{}};if(r.invoked)e.console&&console.error&&void 0;else{var n=function(e,t){e.prototype[t]=function(){return this._q.push({name:t,args:Array.prototype.slice.call(arguments,0)}),this}},s=function(e,t,r){return function(n){e._q.push({name:t,args:Array.prototype.slice.call(r,0),resolve:n})}},o=function(e,t,r){e._q.push({name:t,args:Array.prototype.slice.call(r,0)})},i=function(e,t,r){e[t]=function(){if(r)return{promise:new Promise(s(e,t,Array.prototype.slice.call(arguments)))};o(e,t,Array.prototype.slice.call(arguments))}},a=function(e){for(var t=0;t<g.length;t++)i(e,g[t],!1);for(var r=0;r<m.length;r++)i(e,m[r],!0)};r.invoked=!0;var c=t.createElement("script");c.type="text/javascript",c.integrity="sha384-sBFQqoO3bx3qM8f+iksNzu/E3v0rdkVlvzRqpvP+ynsUk/uaCIsa+NPjw5N04mpg",c.crossOrigin="anonymous",c.async=!0,c.src="https://cdn.amplitude.com/libs/analytics-browser-2.3.3-min.js.gz",c.onload=function(){e.amplitude.runQueuedFunctions||void 0};var u=t.getElementsByTagName("script")[0];u.parentNode.insertBefore(c,u);for(var l=function(){return this._q=[],this},p=["add","append","clearAll","prepend","set","setOnce","unset","preInsert","postInsert","remove","getUserProperties"],d=0;d<p.length;d++)n(l,p[d]);r.Identify=l;for(var v=function(){return this._q=[],this},f=["getEventProperties","setProductId","setQuantity","setPrice","setRevenue","setRevenueType","setEventProperties"],y=0;y<f.length;y++)n(v,f[y]);r.Revenue=v;var g=["getDeviceId","setDeviceId","getSessionId","setSessionId","getUserId","setUserId","setOptOut","setTransport","reset","extendSession"],m=["init","add","remove","track","logEvent","identify","groupIdentify","setGroup","revenue","flush"];a(r),r.createInstance=function(e){return r._iq[e]={_q:[]},a(r._iq[e]),r._iq[e]},e.amplitude=r}}(window,document)}();

var logToolOption = {};
function initLogTool (key, hashedSsoMbrNo, options) {
    if (window.__oyLoginV2TrackingSilence === true) { return; }
    try{
        if(!common.app.appInfo.isapp) {
            if(key.amplitudeApiKey && amplitude) {
                var PLUGIN_TYPE = {
                    BEFORE: "before",
                    ENRICHMENT: "enrichment",
                    DESTINATION: "destination"
                };

                amplitude.add({
                    name: "platform-modifier-plugin",
                    type: PLUGIN_TYPE.ENRICHMENT,
                    setup: async function() {
                        return Promise.resolve(undefined);
                    },
                    execute: async function(event) {
                        event.platform = "Mobile WEB";

                        return Promise.resolve(event);
                    }
                });

                amplitude.init(key.amplitudeApiKey, hashedSsoMbrNo ? hashedSsoMbrNo : "", {
                    defaultTracking: {
                        attribution: false, // 수동 UTM 수집과 충돌 방지를 위해 비활성화
                        pageViews: false,
                        sessions: true,
                        formInteractions: true, // 폼 상호작용 추적 활성화
                        fileDownloads: false,
                    },
                });

                setIdentifyUTM();
                setIdentifyUnder14(options && options.under14Yn);
            }
            if(key.dataplatformApiKey && Dataplatform) {
                Dataplatform.init(key.dataplatformApiKey, hashedGtmMbrNo, options);
            }
        }
        logToolOption = options;
    }catch(e) {
        void 0;
    }
}

function callLogEvent (eventName, eventProperties) {
    if (window.__oyLoginV2TrackingSilence === true) { return; }
    try{
        if(eventName){
            var properties = eventProperties
                ? Object.assign({ log_channel: eventProperties.log_channel ? eventProperties.log_channel : "oy_amp" }, eventProperties)
                : {};

            if(common.app.sendEventTracking(eventName, properties)){
                return;
            }

            if(properties.log_channel === "oy"){
                if(Dataplatform) {
                    Dataplatform.track(eventName, properties);
                }
            } else{
                if(amplitude){
                    amplitude.track(eventName, properties);
                }
                if(Dataplatform) {
                    Dataplatform.track(eventName, properties);
                }
            }
        }
    }catch(e) {
        void 0;
    }
}

var EVENT_PARAMETER = {
    T_PAGE: "t_page",
    T_CLICK: "t_click",
    T_NAME: "t_name",
    T_TYPE: "t_type",
    T_NUMBER: "t_number",
    T_HEADER_TYPE: "t_header_type",
    T_CART_TYPE: "t_cart_type",
    T_LOGO_TYPE: "t_logo_type",
    T_SEARCH_TYPE: "t_search_type",
    T_TODAYDELIVER_TYPE: "t_todaydeliver_type",
    T_OFFLINE_TYPE: "t_offline_type",
    T_RECENT_PRODUCT_TYPE: "t_recent_product_type",
    T_GNB_TYPE: "t_gnb_type",
    T_QUICK_MENU_TYPE: "t_quick_menu_type",
    T_LIST_MENU_TYPE: "t_list_menu_type",
    T_SNS_MENU_TYPE: "t_sns_menu_type",
    T_NAVI_MENU_TYPE: "t_navi_menu_type",
    T_THEME_MENU_TYPE: "t_theme_menu_type",
    T_GENDER_FILTER_TYPE: "t_gender_filter_type",
    T_AGE_FILTER_TYPE: "t_age_filter_type",
    T_CATEGORY_FILTER_TYPE: "t_category_filter_type",
    T_PRICE_FILTER_TYPE: "t_price_filter_type",
    T_CARDTHEME_TYPE: "t_cardtheme_type",
    T_CURATION_MENU_TYPE: "t_curation_menu_type",
    T_RECEIVE_PRODUCT_TYPE: "t_receive_product_type",
    T_DELIVERY_OFFLINE_TYPE: "t_delivery_offline_type",
    T_DOOR_METHOD_TYPE: "t_door_method_type",
    T_CATEGORY_TYPE: "t_category_type",
    T_SCANNER1_TYPE: "t_scanner1_type",
    T_SCANNER2_TYPE: "t_scanner2_type",
    T_DELIVERY_TYPE: "t_delivery_type",
    T_ENTERPRISE_TYPE: "t_enterprise_type",
    T_COUPON_METHOD_TYPE: "t_coupon_method_type",
    T_CHECK_TYPE: "t_check_type",
    T_TIME_TYPE: "t_time_type",
    T_STORE_TYPE: "t_store_type",
    T_SEND_TYPE: "t_send_type",
    T_DELIVERY_TAP_TYPE: "t_delivery_tap_type",
    T_EVENT_FILTER_TYPE: "t_event_filter_type",
    T_TAP_TYPE: "t_tap_type",
    T_PRODUCT_FILTER_TYPE: "t_product_filter_type",
    T_VIEW_FILTER_TYPE: "t_view_filter_type",
    T_TYPE_FILTER_TYPE: "t_type_filter_type",
    T_CONTENTS_FILTER_TYPE: "t_contents_filter_type",
    T_YEAR_TYPE: "t_year_type",
    T_SKIN_TYPE: "t_skin_type",
    T_REVIEW_FILTER_TYPE: "t_review_filter_type",
    T_REVIEW_CLASS_TYPE: "t_review_class_type",
    T_REVIEW_SCORE_TYPE: "t_review_score_type",
    T_REVIEW_SKIN_TYPE: "t_review_skin_type",
    T_REVIEW_TROUBLE_TYPE: "t_review_trouble_type",
    T_REVIEW_MENU_TYPE: "t_review_menu_type",
    T_1ST_CATEGORY_TYPE: "t_1st_category_type",
    T_2ND_CATEGORY_TYPE: "t_2nd_category_type",
    T_3RD_CATEGORY_TYPE: "t_3rd_category_type",
    T_REQUEST_TYPE: "t_request_type",
    T_THEME_NUMBER: "t_theme_number",

    T_AD_NAME: "t_ad_name",
    T_BANNER_NAME: "t_banner_name",
    T_PRODUCT_NAME: "t_product_name",
    T_PLAN_NAME: "t_plan_name",
    T_BRAND_NAME: "t_brand_name",
    T_SEARCH_NAME: "t_search_name",
    T_KEYWORD_NAME: "t_keyword_name",
    T_SEARCH_CATEGORY_NAME: "t_search_category_name",
    T_CAPACITY_NAME: "t_capacity_name",
    T_CARD_NAME: "t_card_name",
    T_EVENT_NAME: "t_event_name",
    T_SHORTS_NAME: "t_shorts_name",
    T_CONTENT_NAME: "t_content_name",
    T_TITLE_NAME: "t_title_name",
    T_POST_NAME: "t_post_name",
    T_REVIEW_NAME: "t_review_name",
    T_PROFILE_NAME: "t_profile_name",
    T_REVIEW_RANK_NAME: "t_review_rank_name",
    T_COLLECTION_NAME: "t_collection_name",
    T_PLACE_NAME: "t_place_name",
    T_MENU_NAME: "t_menu_name",
    T_CARD_NAME: "t_card_name",
    T_AWARDS_NAME: "t_awards_name",
    T_FESTA_NAME: "t_festa_name",
    T_QUESTION_KEYWORD_NAME: "t_question_keyword_name",
    T_HIT_KEYWORD_NAME: "t_hit_keyword_name",
    T_QUESTION_DETAIL_NAME: "t_question_detail_name",
    T_QUESTION_TYPE_NAME: "t_question_type_name",
    T_COUPON_NAME: "t_coupon_name",
    T_COUPON_NUMBER: "t_coupon_number",
    T_POST_NAME: "t_post_name",
    T_VIDEO_NAME: "t_video_name",
    T_MESSAGE_CARD_NAME: "t_message_card_name",
    T_EVENT_NAME: "t_event_name",
    T_AREA_NAME: "t_area_name",
    T_CITY_NAME: "t_city_name",
    T_NOTICE_SEQ : "t_notice_Seq",
    T_GIFTCARD_IMAGE: "t_giftcard_image",
    T_PRODUCT_FLITER_TYPE :"t_product_fliter_type",
    T_REVIEW_RANK : "t_review_rank",

    T_SAVEID:"t_saveid",
    T_AUTOLOGIN:"t_autologin",
    T_AGREE_EVENT:"t_agree_event",
    T_AGREE_SMS:"t_agree_sms",
    T_AGREE_PUSH:"t_agree_push",
    T_DISP_CAT_NO: "t_disp_cat_no",
    T_AGREE_LOC:"t_agree_loc",

    T_DISPCATNO:"t_dispcatno",
    T_PROPERTY1:"t_property1",
    T_PROPERTY2:"t_property2",
    T_PROPERTY3:"t_property3",
    T_PROPERTY4:"t_property4",
    T_PROPERTY5:"t_property5",
    T_PROPERTY6:"t_property6",
    T_PROPERTY7:"t_property7",
    T_PROPERTY8:"t_property8",
    T_PROPERTY9:"t_property9",
    T_PROPERTY10:"t_property10",
    T_VARIANT_GROUP:"t_variant_group",
    T_EXPERIMENT_KEY:"t_experiment_key",
    T_EXPERIMENT_PLATFORM:"t_experiment_platform"
};

var EVENT_PARAMETER_PROPERTY = {
    t_page : "entry_source",
    t_click : "click_source"
}

var STORAGE_KEYS = {
    SESSION: {
        USER_PROPERTIES: "user_properties"
    }
};

/**
 * URL에서 앰플리튜드 이벤트나 utm_xxxxx 등의 parameter를 읽어와서 object 형태로 변경한다.
 * @returns {Key1: value1, Key2: value2}
 */
function getEventParameterObject() {
    try{
        var searchParams = new URL(location.href).searchParams;
        var param = {};

        searchParams.forEach(function(paramValue, paramKey){
            if(EVENT_PARAMETER.hasOwnProperty(paramKey.toUpperCase())) {
                // Event 관련 parameter를 처리
                var propertyKey = EVENT_PARAMETER_PROPERTY[paramKey] || paramKey.replace('t_', '');
                if(!param.hasOwnProperty(propertyKey)) {
                    try {
                        param[propertyKey] = decodeURIComponent(paramValue);
                    } catch (e) {
                        param[propertyKey] = paramValue;
                    }
                }
            }
        });

        return param;
    }catch(e) {
        void 0;
        return {};
    }
}

/**
 * Object를 URL parameter string으로 변경한다.
 * @input obj {key1: value1, key2: value2}
 * @returns "key1=value1&key2=value2"
 */
function getEventParameterString(obj) {
    try {
        var param = [];
        for(var key in obj) {
            if (EVENT_PARAMETER.hasOwnProperty(key.toUpperCase())) {
                param.push(key + "=" + encodeURIComponent(obj[key]));
            }
        }
        return param.join("&");
    } catch(e) {
        void 0;
        return "";
    }
}

/**
 * URL parameter string을 Object로 변환한다.
 * @param {string} paramString e.g."key1=value1&key2=value2"
 * @returns {object} 변환된 object e.g. {key1: value1, key2: value2}
 */
function getParamsToObject(paramString) {
    try{
        return Object.fromEntries(new URLSearchParams(paramString));
    }catch(e) {
        void 0;
        return {};
    }
}
function getParameterFromObject(obj){
    try{
        var param = {};
        for(var paramKey in obj) {
            if(EVENT_PARAMETER.hasOwnProperty(paramKey.toUpperCase())) {
                var propertyKey = EVENT_PARAMETER_PROPERTY[paramKey] || paramKey.replace('t_', '');
                if(!param.hasOwnProperty(propertyKey)) {
                    param[propertyKey] = (obj[paramKey]);
                }
            }
        }
        return param;
    }catch(e) {
        void 0;
        return {};
    }
}

/**
 * UTM 수집을 위한 셋팅
 */
function setIdentifyUTM() {
    try{
        var identifyUTM = new amplitude.Identify();

        var userProperties = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.SESSION.USER_PROPERTIES)) || {
            oy_referrer: document.referrer || "EMPTY",
            landing_url: document.location.href || "EMPTY",
        };

        for (var key in userProperties) {
            identifyUTM.set(key, userProperties[key]);
        }

        sessionStorage.setItem(STORAGE_KEYS.SESSION.USER_PROPERTIES, JSON.stringify(userProperties));

        var urlParams = new URL(window.location.href).searchParams;
        var utmSource = urlParams.get('utm_source') || "";
        var utmMedium = urlParams.get('utm_medium') || "";
        var utmCampaign = urlParams.get('utm_campaign') || "";
        var utmContent = urlParams.get('utm_content') || "";
        var utmTerm = urlParams.get('utm_term') || "";

        if (utmSource !== "") {
            identifyUTM.set('utm_source', utmSource);
            identifyUTM.set('utm_medium', utmMedium);
            identifyUTM.set('utm_campaign', utmCampaign);
            identifyUTM.set('utm_content', utmContent);
            identifyUTM.set('utm_term', utmTerm);
        }

        amplitude.identify(identifyUTM);
    }catch(e){
        void 0
    }
}

/**
 * 기존 파라미터를 지우고 새로운 파라미터 셋팅하기
 * @input deleteParams [name1, name2...] 지우려는 파라미터네임 리스트
 * @input obj parameter obj
 * @returns newUrl replace하려는 url 리턴
 * */
function replaceUrlParameters(obj){
    var url = new URL(location.href);
    var params = new URL(location.href).searchParams;
    for(var key in obj) {
        if(params.has(key)){
            params.delete(key);
        }
    }

    return url.origin+url.pathname+'?'+params.toString()+(params.toString().length > 0?'&':'')+getEventParameterString(obj);
}

function setIdentifyUnder14(under14Yn) {
    try{
        if (under14Yn !== 'Y' && under14Yn !== 'N') {
            return;
        }
        var identify = new amplitude.Identify();
        identify.set('under14_yn', under14Yn);
        amplitude.identify(identify);
    }catch(e){
        void 0;
    }
}